class messageInputConfig {}
messageInputConfig.MAXLENGTH = 300;
messageInputConfig.WARNLENGTH = 275;
export { messageInputConfig };